import React from "react";
import styles from "./RedirectIcon.module.css";
import { ReactComponent as RedirectSVG } from "../../assests/redirect-icon.svg";

/**
 * View component.
 * An icon that displays a symbol for link redirection
 */
export function RedirectIcon() {
  return <RedirectSVG alt="PlusIcon" className={styles.icon} />;
}
